export default () => ({
  organisationCampaigns: {},
  currentPage: 0,
  pages: null,
  currentCampaign: null
})
